import { render, staticRenderFns } from "./ConsultantRecord.vue?vue&type=template&id=3ecf1eb8&scoped=true&"
import script from "./ConsultantRecord.vue?vue&type=script&lang=js&"
export * from "./ConsultantRecord.vue?vue&type=script&lang=js&"
import style0 from "./ConsultantRecord.vue?vue&type=style&index=0&id=3ecf1eb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecf1eb8",
  null
  
)

export default component.exports